import { NgModule } from "@angular/core";
import { DropdownFilterComponent } from "apps-module/app/common-components/dropdown-filter/dropdown-filter.component";
import { PaginationComponent } from "apps-module/app/common-components/pagination/pagination.component";
import { SpinnerComponent } from "apps-module/app/common-components/spinner/spinner.component";
import { SharedLibraryModule } from "apps-module/app/shared-library/shared-library.module";

import { UmbracoLinkComponent } from "./umbraco-link/umbraco-link.component";

@NgModule({
    declarations: [
        SpinnerComponent,
        PaginationComponent,
        DropdownFilterComponent
    ],
    exports: [
        SpinnerComponent,
        SharedLibraryModule,
        PaginationComponent,
        DropdownFilterComponent,
        UmbracoLinkComponent
    ],
    imports: [
        SharedLibraryModule,
        UmbracoLinkComponent
    ]
})
export class CommonComponentsModule { }
